import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWideHalfRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"column-wide-half-remove"} maskId="square-filled-radius-0-stroke-1-IconColumnWideHalfRemove"><path d="M2 4V20L13 20V19L3 19V12.5H22V4H2Z" fill="currentColor"/><path d="M16.5 15.7929L15.7929 16.5L18.2929 19L15.7929 21.5L16.5 22.2071L19 19.7071L21.5 22.2071L22.2071 21.5L19.7071 19L22.2071 16.5L21.5 15.7929L19 18.2929L16.5 15.7929Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconColumnWideHalfRemove;
